import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class AlertaProductoRechazadoExViewModel {
    public IdSolicitudEx: number;
    public Codigo: string;
}

export class AlertaProductoRechazadoExItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: AlertaProductoRechazadoExItemViewModel[];
}

export class AlertaProductoRechazadoExItemViewModel {
    public IdSolicitudEx: number;
    public IdProductoSolicitudEx: number;
    public Codigo: string;
    public FechaEnvio: Date;
    public NifExportador: string;
    public IdPaisDestino: number;
    public IdPaisDestinoDescripcion: string;
    public IdPaisDestinatario: number;
    public IdPaisDestinatarioDescripcion: string;
    public IdEspecie: number;
    public CodigoEppo: string;
    public IdGrupo: number;
    public IdGrupoDescripcion: string;
    public IdForma: number;
    public IdFormaDescripcion: string;
    public NombreCientifico: string;
    public NombreComun: string;
    public Peso: number;
}

export class FilterSearchingAlertaProductoRechazadoExViewModel extends FilterSearchingBaseViewModel {
    public IdEspecie: number;
    public CodigoEppo: string;
    public IdGrupo: number;
    public IdForma: number;
    public NombreCientifico: string;
    public NombreComun: string;
    public Codigo: string;
    public FechaEnvio: Date;
    public NifExportador: string;
    public IdPaisDestino: number;
    public IdPaisDestinatario: number;
}
